import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

const useStyles = makeStyles()((theme) => ({
	container: {
		width: theme.container.width.full,
		height: '100%',
		backgroundColor: theme.gallery.background.color,
		color: theme.palette.neutral[60],
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexFlow: 'column',
		gap: theme.spacing.small,

		['& > *']: {
			flex: '0 0 auto',
		},
	},
	small: {
		gap: theme.spacing.xxsmall,
	},
}));

export default useStyles;
